// extracted by mini-css-extract-plugin
export default {"name":"CellWho_name__sU4KR","role":"CellWho_role__Ty2gU","small":"CellWho_small__LERYS","placeHolderShimmer":"CellWho_placeHolderShimmer__joicf"};